import { Divider, Flex, Space, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Private from "../../../../../Components/Private"
import Icon from "../../../../../Icon"
//import EnrollmentPricingDetailsModal from './EnrollmentPricingDetailsModal'
import Images from "../../../../../Images"
import {
  enrollmentStatusMap,
  isMoneyCharacteristic,
  serviceDescriptionMap
} from "../../../utils/Enrollment.util"

import "./EnrollmentCard.less"

const { Text } = Typography

const serviceImagesMap = {
  ethoca: "ethoca",
  rdr: "visa",
  cdrn: "visa"
}

const EnrollmentCard = ({ enrollment, style, children }) => {
  const { t } = useTranslation()
  const { theme } = useSelector((state) => state.nav)
  const name = enrollment.name.toLowerCase()
  const status = enrollment?.connection_status

  return (
    <Flex vertical style={{ ...style }} className={cls("configure-enrollment-card", {})}>
      <Flex className="name-and-status-block" align="center" gap={8} justify="space-between">
        <Flex align="center" gap={8}>
          <Text strong className="service-name">
            {enrollment?.name}
          </Text>
          <img src={Images[serviceImagesMap[name]]} alt={enrollment?.name} />
          <Text type="secondary" className="service-brand">
            {enrollment?.brand}
          </Text>
        </Flex>
        <div className={cls("enrollment-status", status)}>
          <Text>{enrollmentStatusMap[status]}</Text>
        </div>
      </Flex>

      <Flex gap={8} align="center" className="price-block">
        <Text className="service-price">
          <Private>
            $
            {enrollment.price?.min
              ? enrollment.price?.min !== enrollment.price?.max
                ? `${enrollment.price?.min} - ${enrollment.price?.max}`
                : enrollment.price?.min
              : enrollment.price}
          </Private>
        </Text>
        <Text type="secondary">{t("per alert")}</Text>
      </Flex>

      <Text type="secondary">{serviceDescriptionMap[name]}</Text>

      <Divider />
      <Flex gap={8} vertical>
        {Object.entries(enrollment["list_of_characteristics"]).map(([key, value]) => (
          <Flex className="list-of-characteristics-item" justify="space-between" key={key}>
            <Space>
              <Text>{key}</Text>
            </Space>
            {Array.isArray(value) ? (
              <Flex gap={4}>
                {value.map((v) => (
                  <Icon key={v} type={v} />
                ))}
              </Flex>
            ) : (
              <Text strong>
                <Private disabled={!isMoneyCharacteristic(value)}>{value}</Private>
              </Text>
            )}
          </Flex>
        ))}
      </Flex>

      <Flex align="flex-end" justify="center" style={{ flexGrow: "1", marginTop: 24 }}>
        {children}
      </Flex>
    </Flex>
  )
}
export default EnrollmentCard
